// Small line glyphs this section needs and the shared icon set lacks. They
// are decorative: every control that shows one also names itself in text.
const paths = {
  copy: 'M9 9h10v10H9V9Zm-4 6V5h10',
  check: 'm5 12 4 4L19 6',
  lock: 'M6 11h12v9H6v-9Zm2.5 0V8a3.5 3.5 0 0 1 7 0v3',
  clock: 'M12 7.5V12l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  key: 'M10.6 13.4 20 4m-3 3 2.5 2.5M14.5 9.5l2 2M11 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
  alert: 'M12 8v5m0 3.5v.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
} as const;

export function Glyph({ name, size = 14 }: { name: keyof typeof paths; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="ws-agent-glyph"
    >
      <path d={paths[name]} />
    </svg>
  );
}
